import React from 'react';
import './SortBar.css';

const SortBar = ({ sortOrder, setSortOrder }) => (
    <div className="sort-bar">
        <label className="sort-label">Sort:</label>
        <select
            className="sort-select"
            value={sortOrder}
            onChange={e => setSortOrder(e.target.value)}
        >
            <option value="az">A to Z</option>
            <option value="za">Z to A</option>
        </select>
    </div>
);

export default SortBar;